import RegisterStep1 from "app/components/_organisms/RegisterStep1";
import RegisterStep2 from "app/components/_organisms/RegisterStep2";
import RegisterStep4 from "app/components/_organisms/RegisterStep4";
import RegisterStep5 from "app/components/_organisms/RegisterStep5";
import RegisterStep3 from "app/components/_organisms/RegisterStep3";
import RegisterStep6 from "app/components/_organisms/RegisterStep6";
import RegisterStep7 from "app/components/_organisms/RegisterStep7";
import GlobalLayout from "layout/GlobalLayout";
import { useState } from "react";

const Register = () => {
  const [stepper, setStepper] = useState(1);
  const [value, setValue] = useState(null);

  return (
    <GlobalLayout className={"bg-white min-h-screen py-[72px] px-4"}>
      {stepper === 1 && (
        <RegisterStep1
          value={value}
          nextStepHandler={(Fields) => {
            setValue({ ...value, ...Fields });
            setStepper(2);
          }}
        />
      )}
      {stepper === 2 && (
        <RegisterStep2
          nextStepHandler={(Fields) => {
            setValue({ ...value, ...Fields });
            setStepper(3);
          }}
          prevStepHandler={() => {
            setStepper(1);
          }}
          value={value}
        />
      )}
      {stepper === 3 && (
        <RegisterStep3
          nextStepHandler={(Fields) => {
            setValue({ ...value, ...Fields });
            setStepper(4);
          }}
          prevStepHandler={() => {
            setStepper(2);
          }}
          value={value}
        />
      )}
      {stepper === 4 && (
        <RegisterStep4
          nextStepHandler={(Fields) => {
            setValue({ ...value, ...Fields });
            setStepper(5);
          }}
          prevStepHandler={() => {
            setStepper(3);
          }}
        />
      )}
      {stepper === 5 && (
        <RegisterStep5
          handleChangeStep={(step) => {
            setStepper(step);
          }}
          nextStepHandler={(Fields) => {
            setValue({ ...value, ...Fields });
            setStepper(6);
          }}
        />
      )}
      {stepper === 6 && (
        <RegisterStep6
          handleChangeStep={(step) => {
            setStepper(step);
          }}
          value={value}
        />
      )}
      {stepper === 7 && (
        <RegisterStep7
          handleResetForm={() => {
            setStepper(1);
            setValue(null);
          }}
          value={value}
        />
      )}
    </GlobalLayout>
  );
};
export default Register;
